import { Button, TextField } from '@material-ui/core';
import './SettingCategory.css';
import './SettingChatbot.css';
import ListTagField from './settingCategory/ListTagField';
import { useEffect, useState } from 'react';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import { updatePreviewCategoryListAtom } from '@/state/atom/chatBotPreview';
import { publicGetKnowledgeListAPI } from '@/service/publicService';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { cloneDeep, orderBy } from 'lodash';
import { useRecoilState } from 'recoil';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { getFormById, getInfoFormFieldWithoutAuthen } from '@/service/formManagementService';
import LoadingPanel from '../common/LoadingPanel';
import trI18n from '@/common/utils/trI18n';
import I18n from '@/rI18n';
import { tr, trLabel } from '@/common/utils/tr';
import { getViewDisplayName } from '@/common/utils/ViewUtils';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { getRecoil } from 'recoil-nexus';
import { userAtom } from '@/state/atom/userAtom';
import { resolveUserTimezone } from '@/common/utils/timezoneUtils';

export default function SettingCategory({
    onClickToggleCategorySetting,
    API,
    corporationId,
    projectInuseDetail,
    formQAList,
    customerViewList,
    categoryList,
    setCategoryList,
    chatBotCategorySetting,
    setChatbotCategorySetting,
    isEdited,
    setIsEdited,
    titleCategory,
    setTitleCategory,
    isEditCategoryDetail,
    setIsEditCategoryDetail,
    chatBotCategoryList,
    setChatbotCategoryList,
    editCategoryId,
    setEditCategoryId,
    setIsDisableBtnSubmit    
}) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const [isDataChanged, setIsDataChanged] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isSelectedFormError, setIsSelectedFormError] = useState(false);
    const [messageError, setMessageError] = useState('');
    const [messageSelectedFormError, setMessageSelectedFormError] = useState('');
    const [formIdSelected, setFormIdSelected] = useState(null);
    const [viewIdSelected, setViewIdSelected] = useState(null);
    const [usedTags, setUsedTags] = useState([]);
    const [unusedTags, setUnUsedTags] = useState([]);
    const [optionFormName, setOptionFormName] = useState('');
    const [optionViewName, setOptionViewName] = useState('');
    const [previewCategoryList,setPreviewCategoryList] = useRecoilState(updatePreviewCategoryListAtom);
    const [isOpenConfirmReset, setIsOpenConfirmReset] = useState(false);
    const [isLoading,setIsLoading] = useState(false)

    const onChangeOptionsAutocomplete = async (event, value, listType,isUserOnChange=false) => {
        if(Utils.isEmptyObject(value)) return;

        if (titleCategory.length > 0 && event && !Utils.isEmptyString(formIdSelected))
            setIsDataChanged(true);

        if (listType === 'form') {
            setFormIdSelected(value?.id)

            if(isUserOnChange){
                updatePreviewChatBotWhenEditFormQA(value?.id);
                setIsEdited(true);
                setIsDisableBtnSubmit(false)
            }

        };

        if (listType === 'view') {
            setIsLoading(true);
            setViewIdSelected(value?.id);
            const getTagFieldsParams = {
                affiliationOrganization: corporationId,
                projectId: projectInuseDetail.id,
                structure: value?.structure,
                getApiType: Constant.GET_API_PUBLIC_TYPE.GET_CHAT_BOT_CATEGORY_TAG_FIELD_LIST,
                // TZL-001: resolve AGO dates / UTC range of the view in the current user's timezone
                userTimeZone: resolveUserTimezone(getRecoil(userAtom)?.userSetting)
            };
            const response = await publicGetKnowledgeListAPI(API, getTagFieldsParams);
            setIsLoading(false);
            let tagFieldsOfView = Utils.convertJSONDataToObject(response.payload);
            if (Utils.isEmptyArray(tagFieldsOfView)) tagFieldsOfView = [];

            if (isUserOnChange) {
                updatePreviewChatBotWhenEditView(value?.id, tagFieldsOfView);
                setIsEdited(true);
                setIsDisableBtnSubmit(false)
            }

            let categoryTagFieldList = !Utils.isEmptyArray(chatBotCategorySetting?.tagFields) ? chatBotCategorySetting?.tagFields : [];

            if (isEditCategoryDetail) {
                const chatbotCategoryIds = categoryTagFieldList?.map(tag => {
                    return tag.id;
                });
               
                const newAddedTags = tagFieldsOfView.filter(
                    tag => !chatbotCategoryIds?.includes(tag.id)
                );
                setUnUsedTags(newAddedTags);

                let savedTags = [];
                if (!Utils.isEmptyArray(categoryTagFieldList)) {
                    categoryTagFieldList?.forEach(tag => {
                        const selectedTag = tagFieldsOfView.find(
                            tagField => tagField.id === tag.id
                        );
                        if (selectedTag) savedTags.push({ ...tag, name: selectedTag.name });
                    });
                }
                setUsedTags(savedTags);
                // setIsEditCategoryDetail(false);
            } else {
                let newTagFieldsOfView = tagFieldsOfView.map((item, index) => {
                    let newItem = cloneDeep(item);
                    let tagData = categoryTagFieldList.find(tag => tag.id === item.id);
                    newItem.order = index + 1;
                    newItem.priority = tagData && tagData.priority ? true : false;
                    return newItem;
                });

                newTagFieldsOfView = orderBy(newTagFieldsOfView, [tag => tag.name.toLowerCase()], ['asc']);
                setUsedTags(newTagFieldsOfView);
                setUnUsedTags([]);
            }
        }
    };

    const handleTitleCategory = event => {
        let titleCategoryInput = event.target.value;
        titleCategoryInput.length > 0 && !Utils.isEmptyString(formIdSelected)
            ? setIsDataChanged(true)
            : setIsDataChanged(false);
        if (titleCategoryInput.length > 256) {
            setIsError(true);
            setMessageError(I18n.get('COMMSG037').replace('＜X＞', '256'));
            setIsDataChanged(false);
            return;
        }
        setTitleCategory(titleCategoryInput);
        setMessageError('');
        setIsError(false);
        setIsEdited(true);
        setIsDisableBtnSubmit(false)
    };

    const onClickSaveCategorySetting = async () => {
        if (titleCategory.length === 0) {
            setIsError(true);
            setMessageError(I18n.get('COMMSG014'));
            return;
        }

        if (Utils.isEmptyString(formIdSelected)) {
            let messageErrorInput = trI18n('COMMSG014');
            setIsSelectedFormError(true);
            setMessageSelectedFormError(messageErrorInput);
            return;
        }

        const usedTagsClone = [...usedTags];
        const tagFieldsSetting = usedTagsClone.map((tag, index) => {
            return { id: tag.id, order: index + 1, priority: tag.priority };
        });
        const currentDate = Date.now().toString();
        
        const newChatbotCategorySetting = {
            tempId: editCategoryId ? editCategoryId : currentDate,
            titleCategory: titleCategory,
            formId: formIdSelected,
            viewId: viewIdSelected,
            tagFields: tagFieldsSetting
        };
        if(Utils.getPrefixOfId(newChatbotCategorySetting.tempId) !== 'category'){
            saveDraftCategory(newChatbotCategorySetting)
        }
        let newCategoryList = [];
        if (Utils.isEmptyArray(categoryList)) {
            newCategoryList = [{ id: currentDate, order: 1, name: titleCategory }];
        } else {
            if (editCategoryId) {
                let cloneCategoryList = cloneDeep(categoryList);
                newCategoryList = cloneCategoryList.map(category => {
                    if (category.id === editCategoryId) {
                        category.name = titleCategory;
                        category.edit = true;
                    }
                    return category;
                });
                setEditCategoryId(null);
            } else {
                newCategoryList = [
                    ...categoryList,
                    { id: currentDate, order: categoryList.length + 1, name: titleCategory }
                ];
            }
        }
        setCategoryList(newCategoryList);
        // setChatbotCategorySetting({});
        setChatbotCategoryList([...chatBotCategoryList, newChatbotCategorySetting]);
        setIsEdited(true);
        setIsDisableBtnSubmit(false)
        setIsError(false);
        setMessageError('');
        onClickToggleCategorySetting(false);
        resetComponentSettingCategory();
       
    };

    const onCancelSettingCategory = () => {
        if (isEdited) {
            setIsOpenConfirmReset(true);
            return 
        }
        resetComponentSettingCategory();
        onClickToggleCategorySetting(false);
    }

    const resetComponentSettingCategory = () => {
        setTitleCategory('');
        setChatbotCategorySetting({});
        setUsedTags([]);
        setUnUsedTags([]);
        setFormIdSelected(null);
        setViewIdSelected(null);
    }

    const handleOnBlurTitleCategory = event => {
        if (event.target.value.length === 0) {
            setIsError(true);
            setMessageError(I18n.get('COMMSG014'));
            return;
        }else{
            updatePreviewChatBotWhenEditCategoryName()
        }

    };

    const handleOnBlurFormCategory = event => {
        if (Utils.isEmptyString(formIdSelected)) {
            setIsSelectedFormError(true);
            let messageErrorInput = trI18n('COMMSG014');
            setMessageSelectedFormError(messageErrorInput);
            setIsDataChanged(false)
            return;
        }else{
            setIsError(false);
            setMessageSelectedFormError(null);
        }

    };

    useEffect(() => {
        let selectedForm = {};
        let selectedView = {};

            if (Utils.isEmptyObject(chatBotCategorySetting)) {
                const isExistedFormSystem = formQAList?.some(
                    i => i.definition === Constant.FORM_DEFINITION.SYSTEM
                );

                selectedForm = formQAList.find(form => {
                    //if formQAList is not existed form system, we will default pick head item form list.
                    if (!isExistedFormSystem) return form.type === Constant.FORM_TYPE.FORM_REQ_QA;
                    
                    return (
                        form.type === Constant.FORM_TYPE.FORM_REQ_QA &&
                        form.definition === Constant.FORM_DEFINITION.SYSTEM
                    );
                });

                if (!Utils.isEmptyObject(selectedForm)) {
                    setOptionFormName(getFormDisplayName(selectedForm));
                }

                selectedView = customerViewList.find(
                    view =>
                        (Utils.convertJSONDataToObject(view.structure).ticketProperty ===
                            Constant.TICKET_PROPERTY.SENT ||
                            Utils.isEmptyString(
                                Utils.convertJSONDataToObject(view.structure).ticketProperty
                            )) &&
                        view.viewType === Constant.VIEW_TYPE.DEFAULT
                );
                if (!Utils.isEmptyObject(selectedView)) {
                    setOptionViewName(getViewDisplayNameOfOption(selectedView));
                }
            } else {
                selectedForm = formQAList.find(form => form.id === chatBotCategorySetting.formId);
                if (!Utils.isEmptyObject(selectedForm)) {
                    setOptionFormName(getFormDisplayName(selectedForm));
                } else {
                    selectedForm = formQAList.find(
                        form =>
                            form.type === Constant.FORM_TYPE.FORM_REQ_QA &&
                            form.definition === Constant.FORM_DEFINITION.SYSTEM
                    );
                    if (!Utils.isEmptyObject(selectedForm)) {
                        setOptionFormName(getFormDisplayName(selectedForm));
                    }
                }

                selectedView = customerViewList.find(
                    view => view.id === chatBotCategorySetting.viewId
                );
                if (!Utils.isEmptyObject(selectedView)) {
                    setOptionViewName(getViewDisplayNameOfOption(selectedView));
                }
            }
            onChangeOptionsAutocomplete(null, selectedForm, 'form');
            onChangeOptionsAutocomplete(null, selectedView, 'view');
        
    }, [chatBotCategorySetting, formQAList, customerViewList]);

    useEffect(() => {
        setIsLoading(true)
        const selectedForm = formQAList.find(form => form.id === formIdSelected);
        if (!Utils.isEmptyObject(selectedForm)) {
            setIsLoading(false);
            setOptionFormName(getFormDisplayName(selectedForm));
            getFormById(API,selectedForm?.id).then((formDetail => {
                let usingProjects = formDetail.usingProjects;
                if(!usingProjects.includes({...projectInuseDetail}.id)){
                    setIsSelectedFormError(true);
                    setMessageSelectedFormError(trI18n('MSG-CM-TAG-ITEM-UNAVAILABLE'));
                    setIsLoading(false);
                }else{
                    setIsSelectedFormError(false);
                    setMessageSelectedFormError('');
                    setIsLoading(false);
                }
            }))
        }

        const selectedView = customerViewList.find(view => view.id === viewIdSelected);
        if (!Utils.isEmptyObject(selectedView)) {
            setOptionViewName(getViewDisplayNameOfOption(selectedView));
        }
    }, [formIdSelected, viewIdSelected]);


    const updatePreviewChatBotWhenEditFormQA = async (formId) => {
        
        let previewCategoryListClone = cloneDeep(previewCategoryList);
        let indexOfEditCategory = previewCategoryListClone.findIndex((category) => {
            return category.id === editCategoryId
        })

        if(indexOfEditCategory >= 0){

            let cloneEditCategory = previewCategoryListClone[indexOfEditCategory];
            cloneEditCategory[`chatBotCategorySetting`].formId = formId;
            let formfieldAnonymous = await getInfoFormFieldWithoutAuthen(API, formId);
            if (!Utils.isEmptyObject(formfieldAnonymous)) {
                cloneEditCategory['formfieldAnonymous'] = formfieldAnonymous;
            }
            previewCategoryListClone[indexOfEditCategory] = cloneEditCategory;
            setPreviewCategoryList([...previewCategoryListClone])
        }
    }

    const updatePreviewChatBotWhenEditView = (viewId,listTag) => {
        let previewCategoryListClone = cloneDeep(previewCategoryList);
        let indexOfEditCategory = previewCategoryListClone.findIndex((category) => {
            return category.id === editCategoryId
        })
        
        if(indexOfEditCategory >= 0){
            let cloneEditCategory = previewCategoryListClone[indexOfEditCategory];
            
            cloneEditCategory[`chatBotCategorySetting`].viewId = viewId
            cloneEditCategory.listTagFiledId = listTag.map((tagFiled) => {
                return tagFiled.id
            });
            cloneEditCategory[`chatBotCategorySetting`].tagFields = listTag.map((tagFiled,index) => {
                return {id:tagFiled.id,order: index+1,priority: false }
            })
            previewCategoryListClone[indexOfEditCategory] = cloneEditCategory
            setPreviewCategoryList([...previewCategoryListClone])
        }
    }

    const saveDraftCategory = (newCategory) => {
        let previewCategoryListClone = cloneDeep(previewCategoryList);
        
        let indexOfEditCategory = previewCategoryListClone.findIndex((category) => {
            return category.id === newCategory.tempId
        })
        let listTagFieldIdOfNewCategory = newCategory?.tagFields?.map(tagFiled => {
            return tagFiled.id
        })
        const viewDetail = customerViewList.find(view =>  view.id === newCategory.viewId)
        let newCategoryObject = {
            id: newCategory.tempId,
            chatBotCategorySetting: {
                formId: newCategory.formId,
                viewId: newCategory.viewId,
                tagFields: newCategory.tagFields
            },
            name: {
                
                    "jp": {
                        "A": "F",
                        "text": newCategory.titleCategory
                    }
                
            },
            listTagFiledId: listTagFieldIdOfNewCategory,
            viewStructure: Utils.convertJSONDataToObject(viewDetail?.structure)
        }
        
        
        if(indexOfEditCategory < 0){
            previewCategoryListClone.push(newCategoryObject)
        }else{
            previewCategoryListClone[indexOfEditCategory] = newCategoryObject
        }
        setPreviewCategoryList(previewCategoryListClone)
    }

    const updatePreviewChatBotWhenEditCategoryName = () => {
        
        let previewCategoryListClone = cloneDeep(previewCategoryList);
        let indexOfEditCategory = previewCategoryListClone.findIndex((category) => {
            return category.id === editCategoryId
        })

        if(indexOfEditCategory >= 0){
            
            let cloneEditCategory = previewCategoryListClone[indexOfEditCategory];
            
            cloneEditCategory.name =    {
                "jp": {
                    "A": "F",
                    "text": titleCategory
                }
            }
         
            previewCategoryListClone[indexOfEditCategory] = cloneEditCategory
            setPreviewCategoryList([...previewCategoryListClone])
        }
    }

    const filterSuggetOption = createFilterOptions({
        ignoreCase: false,
        stringify: option => `${option.name}`
    });

    // Display name for a form option: group 2 -> "translated (original)" via trLabel.
    // `option.name` is already the flattened JP source string.
    const getFormDisplayName = option => (option?.name ? trLabel(option.name) : '');

    // Display name for a view option: system (DEFAULT) view is translated, custom view kept
    // as-is (getViewDisplayName). Needs the original JSON name + viewType, so use `nameOrigin`
    // (kept in the parent) instead of the flattened `name`.
    const getViewDisplayNameOfOption = option =>
        option ? getViewDisplayName({ name: option.nameOrigin, viewType: option.viewType }) : '';

    const getOptionDisplayName = (option, listType) =>
        listType === 'form' ? getFormDisplayName(option) : getViewDisplayNameOfOption(option);

    const renderAutocompleteField = (options, listType, optionName) => {
        if (listType === 'form')
            return (
                <Autocomplete
                    value={optionName}
                    filterSelectedOptions={true}
                    getOptionLabel={option => getOptionDisplayName(option, listType) || optionName}
                    filterOptions={filterSuggetOption}
                    disableClearable
                    disablePortal={true}
                    className="mui-complete-category"
                    options={options}
                    onChange={(event, value) =>
                        onChangeOptionsAutocomplete(event, value, listType, true)
                    }
                    onBlur={(e)=> handleOnBlurFormCategory(e)}
                    renderInput={params => (
                        <TextField
                            {...params}
                            variant="outlined"
                            inputProps={{
                                ...params.inputProps,
                                className: 'input-category-autocomplete'
                            }}
                            error={isSelectedFormError}
                            helperText={messageSelectedFormError}
                        />
                    )}
                    renderOption={option => (
                        <OverFlowTooltipWithTabsMui
                            value={getOptionDisplayName(option, listType)}
                            className="item-options-acmp"
                        />
                    )}
                    noOptionsText={trI18n('COMMSG001')}
                />
            );
        return (
            <Autocomplete
                value={optionName}
                filterSelectedOptions={true}
                getOptionLabel={option => getOptionDisplayName(option, listType) || optionName}
                filterOptions={filterSuggetOption}
                disableClearable
                disablePortal={true}
                className="mui-complete-category"
                options={options}
                onChange={(event, value) =>
                    onChangeOptionsAutocomplete(event, value, listType, true)
                }
                renderInput={params => (
                    <TextField
                        {...params}
                        variant="outlined"
                        inputProps={{
                            ...params.inputProps,
                            className: 'input-category-autocomplete'
                        }}
                    />
                )}
                renderOption={option => (
                    <OverFlowTooltipWithTabsMui
                        value={getOptionDisplayName(option, listType)}
                        className="item-options-acmp"
                    />
                )}
                noOptionsText={trI18n('COMMSG001')}
            />
        );
    };

    

    return (
        <div className="setting-category-wrapper">
            <LoadingPanel isLoading={isLoading} />
            {/* header  */}
            <div className="header-category-setting">
                <h3 className="title">{tr('質問カテゴリ設定')}</h3>
                <div className="group-btn">
                    <Button
                        variant="contained"
                        className="btn-hg32 btn-light"
                        color="primary"
                        onClick={() => onCancelSettingCategory()}
                    >
                        {tr('キャンセル')}
                    </Button>
                    <Button
                        variant="contained"
                        className="btn-hg32 btn-primary"
                        color="primary"
                        disabled={!isDataChanged || isSelectedFormError}
                        onClick={() => onClickSaveCategorySetting()}
                    >
                        {trI18n('COMBTN011')}
                    </Button>
                </div>
            </div>

            {/* select options form and view */}
            <div className="select-option-category">
                {/* set name category  */}
                <div className="title-category">
                    <div className="title category-mb8">
                        {tr('質問カテゴリ名')}
                        <span className="required">*</span>
                    </div>
                    <TextField
                        className="form-control-wrapInput form-control-hg48 category-mb8"
                        fullWidth
                        variant="outlined"
                        placeholder={tr('質問カテゴリ名を入力ください。')}
                        value={titleCategory}
                        error={isError}
                        helperText={tr(messageError)}
                        onChange={handleTitleCategory}
                        onBlur={handleOnBlurTitleCategory}
                    />
                </div>
                {/* select list form  */}
                <div className="select-list-form">
                    <div className="title category-mb8">
                        {tr('問い合わせフォーマット')} <span className="required">*</span>
                    </div>
                    {renderAutocompleteField(formQAList, 'form', optionFormName)}
                </div>

                {/* select list tab views  */}
                <div className="select-list-form">
                    <div className="title category-mb8">{tr('ナレッジ絞り込み条件')}</div>
                    {renderAutocompleteField(customerViewList, 'view', optionViewName)}
                </div>
                <h3 className="title">{tr('質問項目詳細設定')}</h3>
            </div>

            {/* list tag field active and inactive  */}
            <ListTagField
                usedTags={usedTags}
                unusedTags={unusedTags}
                setUsedTags={setUsedTags}
                setUnUsedTags={setUnUsedTags}
                projectName={projectInuseDetail.name}
                editCategoryId={editCategoryId}
                setIsEdited={setIsEdited}
                setIsDataChanged={setIsDataChanged}
                setIsDisableBtnSubmit={setIsDisableBtnSubmit}
            />

            <ConfirmDialog
                isOpen={isOpenConfirmReset}
                msgConfirm={trI18n('USER12MSG010')}
                closeCallBack={() => setIsOpenConfirmReset(false)}
                okCallBack={() => {
                    onClickToggleCategorySetting(false);
                    setIsOpenConfirmReset(false);
                    resetComponentSettingCategory();
                    setIsEdited(false);
                }}
                textClose={trI18n('COMBTN007')}
            />
        </div>
    );
}
